/**
 * Collection Billboard Lazy Loader
 * Loads billboard popup content dynamically from theme settings via data attributes
 * No hardcoded configuration needed - all content is managed through Shopify admin
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // Insert billboard after first product (client-side insertion for better performance)
  // Retry to handle cases where bc-sf-filter injects products after DOMContentLoaded
  insertBillboardAfterFirstProduct();
  
  const triggers = document.querySelectorAll('.collection-billboard-trigger');
  
  triggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Get all billboard data from data attributes (populated by Liquid from theme settings)
      const collection = this.dataset.collection;
      const billboardKey = this.dataset.billboardKey;
      const title = this.dataset.billboardTitle;
      const text = this.dataset.billboardText;
      const link1Text = this.dataset.billboardLink1Text;
      const link1Url = this.dataset.billboardLink1Url;
      const link2Text = this.dataset.billboardLink2Text;
      const link2Url = this.dataset.billboardLink2Url;
      const billboardType = this.dataset.billboardType;
      const useDirectLink = this.dataset.billboardUseDirectLink === 'true';
      
      // If direct link mode is enabled and URL exists, open link directly
      if (useDirectLink && link1Url) {
        window.location.href = link1Url;
        return;
      }
      
      const popupEl = document.getElementById(`CollectionBillboard-${collection}`);
      
      if (!popupEl) {
        console.error(`Popup element not found: CollectionBillboard-${collection}`);
        return;
      }
      
      // Load content only once (lazy load on first click)
      if (popupEl.dataset.loaded === 'false') {
        // Build popup HTML from theme settings data
        let popupHTML = `
          <div class="PopupSideBar_Close">
            <button onclick="PopupSideBar('CollectionBillboard-${collection}')" class="PopupBtn_StylesUnset">
              <img class="PopupSideBar_Close_Img lazy" 
                   src="${window.lazPlaceholder || ''}" 
                   data-src="${window.popupCloseIcon || ''}" 
                   alt="Sidebar close"> CLOSE
            </button>
          </div>  
        `;
        
        // Add title if provided
        if (title) {
          popupHTML += `<h3>${title}</h3>`;
        }
        
        // Add text if provided
        if (text) {
          popupHTML += `<p>${text}</p>`;
        }
        
        // Add link buttons if provided
        if (link1Text && link1Url) {
          popupHTML += `
            <a href="${link1Url}" target="_blank">
              <button class="PopupSideBar_ExtraButton" style="display: block;">${link1Text}</button>
            </a>
          `;
        }
        
        if (link2Text && link2Url) {
          popupHTML += `
            <a href="${link2Url}" target="_blank">
              <button class="PopupSideBar_ExtraButton" style="display: block;">${link2Text}</button>
            </a>
          `;
        }
        
        popupEl.innerHTML = popupHTML;
        
        popupEl.dataset.loaded = 'true';
        
        // Initialize lazy loading for newly added images
        if (window.lazyLoadInstance && window.lazyLoadInstance.update) {
          window.lazyLoadInstance.update();
        }
        
        // Content loaded, now open the popup
        if (typeof PopupSideBar === 'function') {
          PopupSideBar(`CollectionBillboard-${collection}`);
        } else {
          console.error('PopupSideBar function not found');
        }
      } else {
        // Content already loaded, just open popup
        if (typeof PopupSideBar === 'function') {
          PopupSideBar(`CollectionBillboard-${collection}`);
        } else {
          console.error('PopupSideBar function not found');
        }
      }
    });
  });
});

/**
 * Insert billboard after the first product in collection
 * Moves the billboard element from its initial position to after the first product
 * This improves page load performance by handling insertion client-side
 * Retries up to 20 times to handle third-party apps (e.g. bc-sf-filter) that inject products after DOMContentLoaded
 */
function insertBillboardAfterFirstProduct(attempt = 0) {
  const maxAttempts = 20;
  const retryDelay = 200;

  // Only insert billboard on page 1
  const pageParam = new URLSearchParams(window.location.search).get('page');
  if (pageParam && parseInt(pageParam) > 1) return;

  const productsGrid = document.querySelector('.grid-uniform.main-grid.products');
  
  if (!productsGrid) {
    if (attempt < maxAttempts) setTimeout(() => insertBillboardAfterFirstProduct(attempt + 1), retryDelay);
    return;
  }
  
  // Find the billboard element (should be rendered in the template but hidden/at end)
  const billboard = productsGrid.querySelector('.collection-promo-tile');
  
  if (!billboard) {
    return;
  }
  
  // Remove billboard from its current position FIRST
  billboard.remove();
  
  // Now find all actual product items (after billboard is removed)
  const allChildren = Array.from(productsGrid.children);
  
  const products = allChildren.filter(child => {
    const isProductSmaller = child.classList.contains('product-smaller');
    const isEmpty = child.classList.contains('product-smaller-empty');
    const isPagination = child.classList.contains('pagination-block-url');
    
    return isProductSmaller && !isEmpty && !isPagination;
  });
  
  // If no products yet, retry (bc-sf-filter may not have injected them yet)
  if (products.length === 0) {
    productsGrid.prepend(billboard); // put it back temporarily
    if (attempt < maxAttempts) setTimeout(() => insertBillboardAfterFirstProduct(attempt + 1), retryDelay);
    return;
  }

  // Insert billboard BEFORE first actual product
  products[0].insertAdjacentElement('beforebegin', billboard);
}
